import React from 'react'
import Image from 'next/image'
import { ButtonVariant, MaxWidthConstraint, OvalButton, WorkArea } from '@revelrygroup/components'

import styles from './styles.module.scss'
import EventTrackingModel from '../../models/EventTrackingModel'

interface IntroColumn {
  title: string
  description: string
  buttonLabel: string
  href: string
  onClick?: () => void
}

const columns: IntroColumn[] = [
  {
    title: 'Arlington National Cemetery Services',
    description:
      'Experienced guidance for families across the nation and around the world navigating Arlington National Cemetery services, military honors, transportation logistics, and every important detail with dignity, precision, and care.',
    buttonLabel: 'Arlington National Cemetery Services',
    href: '#contact-form',
    onClick: () => EventTrackingModel.trackArlingtonServicesButtonClick('intro'),
  },
  {
    title: 'Full Veteran Services in the DMV',
    description:
      'Proudly serving veterans and military families throughout Maryland, Washington DC, and Virginia with meaningful funeral, crematory, memorial, and military honor services.',
    buttonLabel: 'Full Veteran Services in the DMV',
    href: '#full-veteran-services',
  },
]

const VeteranServicesIntro: React.FC = () => {
  return (
    <WorkArea>
      <MaxWidthConstraint>
        <h2 className="h2 centered-text">Serving Those Who Served</h2>

        <div className={styles.columns}>
          {columns.map((column, index) => (
            <div
              key={column.title}
              className={`${styles.column} ${index === 1 ? styles.columnWithDivider : ''}`}
            >
              <div className="centered-text">
                <Image
                  alt="Kalas Funeral Home logo"
                  height={60}
                  layout="fixed"
                  src="/kalas-radian--blue.png"
                  width={60}
                />
              </div>

              <h3 className="h6 centered-text">{column.title}</h3>

              <p className="centered-text">{column.description}</p>

              <div className={styles.buttonRow}>
                <OvalButton
                  as="Link"
                  href={column.href}
                  variant={ButtonVariant.DEFAULT_DARK}
                  onClick={column.onClick}
                >
                  {column.buttonLabel}
                </OvalButton>
              </div>
            </div>
          ))}
        </div>
      </MaxWidthConstraint>
    </WorkArea>
  )
}

export default VeteranServicesIntro
